import { Component, OnInit, ChangeDetectionStrategy, Input, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { coverAnimation, modalAnimation } from '../animations';
import { ModalInstanceService } from '../form-core/modal/modal-instance.service';

@Component({
  selector: 'div[data-component-type=modal-service-status]',
  templateUrl: './modal-service-status.component.html',
  styleUrls: ['./modal-service-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [coverAnimation, modalAnimation]
})
export class ModalServiceStatusComponent implements OnInit, AfterViewInit {

  @Input() title!: string
  @Input() subTitle!: string
  @Input() content: any

  @ViewChild('modal') modalEl!: ElementRef<HTMLDivElement>
  @ViewChild('wrapper') wrapperEl!: ElementRef<HTMLDivElement>

  iconInWrapper: boolean = true

  constructor(private cd: ChangeDetectorRef, private modalInstance: ModalInstanceService) { }

  ngOnInit(): void {
  }

  @HostListener('mousedown') destroyInstance() {
    this.modalInstance.destroy()
  }

  stopBehaviour(event: MouseEvent) {
    event.stopPropagation()
    event.preventDefault()
  }

  ngAfterViewInit() {
    if (this.wrapperEl.nativeElement.offsetHeight - this.modalEl.nativeElement.offsetHeight === 90) {
      setTimeout(() => {
        this.iconInWrapper = false
        this.cd.markForCheck()
      }, 0);
    }
  }

}